<label class="radio radio-gradient">
  <span class="radio__input">
    <input type="radio" #optionInput [name]="schedulequestionid" [attr.class]="schedulequestionid"
      [value]="option.optionid" id="{{option.optionid}}" [checked]=option.selected (change)="onRadioButtonClick(option)"
      [attr.aria-labelledby]="'label-' + option.optionid">
    <span class="radio__control"></span>
  </span>
  <span tabindex="-1" aria-hidden="true" #optionhtmlspan class="radio__label" style=" font-size: 18px !important;" [id]="'label-' + option.optionid"></span>
</label>